type TrustCircleChange = { kind: 'remove' | 'add'; userId: string };

/** Each edit depends on the previous result, including its retry-baseline update. */
export function applyTrustCircleChanges({
  baseline,
  selectedIds,
  add,
  remove,
  onApplied,
}: {
  baseline: ReadonlySet<string>;
  selectedIds: readonly string[];
  add: (userId: string) => Promise<unknown>;
  remove: (userId: string) => Promise<unknown>;
  onApplied: (change: TrustCircleChange) => void;
}): Promise<void> {
  const selected = new Set(selectedIds);
  const changes: TrustCircleChange[] = [];
  for (const userId of baseline) {
    if (!selected.has(userId)) changes.push({ kind: 'remove', userId });
  }
  for (const userId of selectedIds) {
    if (!baseline.has(userId)) changes.push({ kind: 'add', userId });
  }
  // A rejection skips every remaining edit. Do not start later writes in parallel:
  // callers must know which changes succeeded before offering a retry.
  return changes.reduce(
    (previous, change) =>
      previous.then(async () => {
        await (change.kind === 'remove' ? remove : add)(change.userId);
        onApplied(change);
      }),
    Promise.resolve(),
  );
}
